export default function gettermParams(term, postType) {
  const { name, slug, taxonomy } = term || {}

  if (!name && (!taxonomy || !postType)) {
    return null
  }

  let baseUrl = ''

  switch (postType) {
    case 'all-news':
      baseUrl = `/news/?wp_posts_all-news`

      break

    case 'all-events':
      baseUrl = `/events/?wp_posts_all-events`

      break

    case 'all-work':
      baseUrl = `/insights/?wp_posts_all-work`

      break

    default:
      break
  }

  let termParams = ''

  switch (taxonomy) {
    case 'all-event-types':
      termParams = `${encodeURI(`[refinementList][types_taxonomy.name][0]=${name}`)}`

      break

    case 'all-event-formats':
      termParams = `${encodeURI(`[refinementList][formats_taxonomy.name][0]=${name}`)}`
      break

    case 'all-topics':
      baseUrl = '/topics/'
      termParams = slug ? slug : ''
      break

    default:
      break
  }

  return `${baseUrl}${termParams}`
}
